import { render, staticRenderFns } from "./Withdrawal.vue?vue&type=template&id=6c211cb3&scoped=true&"
import script from "./Withdrawal.vue?vue&type=script&lang=ts&"
export * from "./Withdrawal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c211cb3",
  null
  
)

export default component.exports